<template>
  <b-overlay :show="busy" rounded="sm">
    <b-card class="standardpage reports invoices border-none">
      <div class="availtable datatable">
        <b-card class="w-100pct">
          <b-card-body class="py-0 px-0">
            <b-tabs class="gridtabs">

              <b-tab active>
                <template #title>
                  <i :class="'fa fa-book text-primary'" class="text-primary mr-1"></i>
                  {{ item.locator }}
                </template>

                <b-tabs class="mt-4">
                  <b-tab active>
                    <template #title>
                      <div class="badgecontainer pr-1 mr-1">
                        <i class="fa fa-plane text-primary ml-1 mr-1"></i> Sectors
                        <b-badge v-if="segments.items.length > 0" variant="white" class="edit_tab">
                          {{ segments.items.length }}</b-badge>
                      </div>
                    </template>

                    <p class="py-0 px-0">
                      <b-row>
                        <b-col>
                          <d-table classdivtable="availtable datatable nested" refid="segments" :icon="segments.icon"
                            :selectmode="'single'" :busy="segments.busy" :tools="segments.tools"
                            :badges="segments.badges" :fields="segments.fields" :items="segments.items"
                            :showpages="false" :showrowcount="false" @load="load" @click="segments_click"
                            @select="segments_select">
                          </d-table>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col class="text-left">
                          <div v-if="busy">
                            <i class="fa fa-spinner fa-spin text-primary"></i>
                          </div>
                          <div v-else>
                            <span v-html="message"></span>
                          </div>
                        </b-col>
                      </b-row>
                    </p>

                  </b-tab>

                  <b-tab v-if="segments.item.id">
                    <template #title>
                      <i class="fa fa-plane text-primary mr-1"></i> Sector
                      <span class="text-warning">&lt;{{ segments.item.id ? "edit" : "new" }}&gt;</span>
                    </template>

                    <div class="px-2 mt-3 mb-3">
                      <!-- :disabled="readonly()" -->
                      <b-row>
                        <b-col cols="12" sm="6" md="4" xl="3">
                          <b-form-group label-cols="12" label="Vendor Locator" label-size="sm">
                            <b-input-group>
                              <b-form-input v-model="segments.item.vendorlocator" :debounce="options.debounce"
                                :disabled="false" placeholder="Vendor Locator" trim></b-form-input>
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary"
                                  @click="segments.item.vendorlocator = ''" :disabled="false">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>

                        <b-col cols="12" sm="6" md="4" xl="3">
                          <b-form-group label-cols="12" label="Class Code" label-size="sm">
                            <b-input-group>
                              <b-form-input v-model="segments.item.classcode" :debounce="options.debounce"
                                :disabled="false" placeholder="Class Code" trim list="list-classes"></b-form-input>
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="segments.item.classcode = ''"
                                  :disabled="false">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="6" md="4" xl="3">
                          <b-form-group label-cols="12" label="Flight No" label-size="sm">
                            <b-input-group>
                              <b-form-input v-model="segments.item.flightno" :debounce="options.debounce"
                                :disabled="false" placeholder="Flight Number" trim></b-form-input>
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="segments.item.flightno = ''"
                                  :disabled="false">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="6" md="4" xl="3">
                          <b-form-group label="Marketing Carrier" label-for="marketingcarrier" label-cols="12">
                            <treeselect placeholder="Select carrier..." v-model="segments.item.marketingcarrier"
                              searchPromptText="Type at least 3 chars..." :clearable="true" :async="true"
                              :load-options="treeselect_loadAirline" :show-count="true" :flatten-search-results="true"
                              :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                              <div slot="value-label" slot-scope="{ node }">
                                {{ node.raw.id }}
                              </div>
                            </treeselect>
                          </b-form-group>
                        </b-col>
                        <!-- <b-col cols="12" sm="6" md="4" xl="3">
      <b-form-group
        label-cols="12"
        label="Marketing Carrier"
        label-size="sm"
      >
        <b-input-group>
          <b-form-input
            v-model="segments.item.marketingcarrier"
            :debounce="options.debounce"
            :disabled="false"
            :title="segments.item.marketingcarriername"
            placeholder="Marketing Carrier"
            trim
          ></b-form-input>
          <b-input-group-append>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="
                segments.item.marketingcarrier = ''
              "
               :disabled="false"
            >
              <i class="fa fa-remove"></i>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-col> -->
                        <b-col cols="12" sm="6" md="4" xl="3">
                          <b-form-group label="Operating Carrier" label-for="operatingcarrier" label-cols="12">
                            <treeselect placeholder="Select carrier..." v-model="segments.item.operatingcarrier"
                              searchPromptText="Type at least 3 chars..." :clearable="true" :async="true"
                              :load-options="treeselect_loadAirline" :show-count="true" :flatten-search-results="true"
                              :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                              <div slot="value-label" slot-scope="{ node }">
                                {{ node.raw.id }}
                              </div>
                            </treeselect>
                          </b-form-group>
                        </b-col>
                        <!-- <b-col cols="12" sm="6" md="4" xl="3">
      <b-form-group
        label-cols="12"
        label="Operating Carrier"
        label-size="sm"
      >
        <b-input-group>
          <b-form-input
            v-model="segments.item.operatingcarrier"
            :debounce="options.debounce"
            :disabled="false"
            :title="segments.item.operatingcarriername"
            placeholder="Operating Carrier"
            trim
          ></b-form-input>
          <b-input-group-append>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="
                segments.item.operatingcarrier = ''
              "
              :disabled="false"
            >
              <i class="fa fa-remove"></i>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-col> -->
                        <b-col cols="12" sm="6" md="4" xl="3">
                          <b-form-group label="Aircraft" label-for="aircraft" label-cols="12">
                            <treeselect placeholder="Select aircraft..." v-model="segments.item.aircraft"
                              searchPromptText="Type at least 3 chars..." :clearable="true" :async="true"
                              :load-options="treeselect_loadAircraft" :show-count="true" :flatten-search-results="true"
                              :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                              <div slot="value-label" slot-scope="{ node }">
                                {{ node.raw.id }}
                              </div>
                            </treeselect>
                          </b-form-group>
                        </b-col>

                        <b-col cols="12" sm="6" md="4" xl="3">
                          <b-form-group label-cols="12" label="Start DateTime" label-size="sm">
                            <b-input-group>
                              <daterangepicker style="width:auto !important" size="sm" ref="date" v-model="datestart"
                                :opens="'right'" :single-date-picker="'single'" :locale-data="{
                                  direction: 'ltr',
                                  format: 'dd/mm/yy HH:MM',
                                  daysOfWeek: [
                                    'Sun',
                                    'Mon',
                                    'Tue',
                                    'Wed',
                                    'Thu',
                                    'Fri',
                                    'Sat',
                                  ],
                                  monthNames: [
                                    'January',
                                    'February',
                                    'March',
                                    'April',
                                    'May',
                                    'June',
                                    'July',
                                    'August',
                                    'September',
                                    'October',
                                    'November',
                                    'December',
                                  ],
                                  firstDay: 1,
                                }" :ranges="false" :showDropdowns="true" :linkedCalendars="true" :timePicker="true"
                                :timePicker24Hour="true" :time-picker-increment="1">
                              </daterangepicker>
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="datestart = {
                                  startDate: null,
                                  endDate: null,
                                }
                                  ">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>


                        <b-col cols="12" sm="6" md="4" xl="3">

                          <b-form-group label-cols="12" label="Start City" label-size="sm">
                            <treeselect placeholder="Select city..." searchPromptText="Type at least 3 chars..."
                              v-model="segments.item.startcity" :disabled="false" :clearable="true" :async="true"
                              :load-options="treeselect_loadIATA" :show-count="true" :flatten-search-results="true"
                              :disable-branch-nodes="true" :matchKeys="['id']" :title="segments.item.startcity +
                                ' ( ' +
                                segments.item.startcityname +
                                ' )'
                                " search-nested>
                              <div slot="value-label" slot-scope="{ node }">
                                {{ node.raw.id }} (
                                {{ segments.item.startcityname }} )
                              </div>
                            </treeselect>
                          </b-form-group>
                        </b-col>

                        <b-col cols="12" sm="6" md="4" xl="3">
                          <b-form-group label-cols="12" label="Start Terminal" label-size="sm">
                            <b-input-group>
                              <b-form-input v-model="segments.item.startterminal" :disabled="false"
                                :debounce="options.debounce" placeholder="Start Terminal" trim
                                list="list-terminal"></b-form-input>
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="segments.item.startterminal = ''
                                  " :disabled="false">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>


                        <b-col cols="12" sm="6" md="4" xl="3">
                          <b-form-group label-cols="12" label="Duration (HH:MM:SS)" label-size="sm">
                            <b-input-group>
                              <b-form-input v-model="segments.item.duration" :debounce="options.debounce"
                                :disabled="false" placeholder="Duration" trim></b-form-input>
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="segments.item.duration = ''"
                                  :disabled="false">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>

                        <b-col cols="12" sm="6" md="4" xl="3">
                          <b-form-group label-cols="12" label="End DateTime" label-size="sm">
                            <b-input-group>
                              <daterangepicker size="sm" ref="date" v-model="dateend" :opens="'right'"
                                :single-date-picker="'single'" :locale-data="{
                                  direction: 'ltr',
                                  format: 'dd/mm/yy HH:MM',
                                  daysOfWeek: [
                                    'Sun',
                                    'Mon',
                                    'Tue',
                                    'Wed',
                                    'Thu',
                                    'Fri',
                                    'Sat',
                                  ],
                                  monthNames: [
                                    'January',
                                    'February',
                                    'March',
                                    'April',
                                    'May',
                                    'June',
                                    'July',
                                    'August',
                                    'September',
                                    'October',
                                    'November',
                                    'December',
                                  ],
                                  firstDay: 1,
                                }" :ranges="false" :showDropdowns="true" :linkedCalendars="true" :timePicker="true"
                                :timePicker24Hour="true" :time-picker-increment="1">
                              </daterangepicker>
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="dateend = {
                                  startDate: null,
                                  endDate: null,
                                }
                                  ">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>

                        <b-col cols="12" sm="6" md="4" xl="3">

                          <b-form-group label-cols="12" label="End City" label-size="sm">
                            <treeselect placeholder="Select city..." searchPromptText="Type at least 3 chars..."
                              v-model="segments.item.endcity" :disabled="false" :clearable="true" :async="true"
                              :load-options="treeselect_loadIATA" :show-count="true" :flatten-search-results="true"
                              :disable-branch-nodes="true" :matchKeys="['id']" :title="segments.item.endcity +
                                ' ( ' +
                                segments.item.endcityname +
                                ' )'
                                " search-nested>
                              <div slot="value-label" slot-scope="{ node }">
                                {{ node.raw.id }} (
                                {{ segments.item.endcityname }} )
                              </div>
                            </treeselect>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="6" md="4" xl="3">
                          <b-form-group label-cols="12" label="End Terminal" label-size="sm">
                            <b-input-group>
                              <b-form-input v-model="segments.item.endterminal" :disabled="false"
                                :debounce="options.debounce" placeholder="End Terminal" trim
                                list="list-terminal"></b-form-input>
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="segments.item.endterminal = ''
                                  " :disabled="false">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>

                        <b-col cols="12" sm="6" md="4" xl="3">
                          <b-form-group label-cols="12" label="Distance (Miles)" label-size="sm">
                            <b-input-group>
                              <b-form-input v-model="segments.item.distance" :debounce="options.debounce"
                                :disabled="false" placeholder="Distance" trim></b-form-input>
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="segments.item.distance = ''"
                                  :disabled="false">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>

                        <b-col cols="12" sm="6" md="4" xl="3">
                          <b-form-group label-cols="12" label="Class Name" label-size="sm">
                            <b-input-group>
                              <b-form-input v-model="segments.item.classname" :debounce="options.debounce"
                                :disabled="false" placeholder="Class Name" trim></b-form-input>
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="segments.item.classname = ''"
                                  :disabled="false">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="6" md="4" xl="3">
                          <b-form-group label-cols="12" label="Cabin" label-size="sm">
                            <treeselect placeholder="Cabin" v-model="segments.item.cabin" :clearable="true"
                              :multiple="false" :options="options_cabin" :matchKeys="['id']" :disabled="false">
                              <div slot="value-label" slot-scope="{ node }">
                                {{ node.raw.id }}
                              </div>
                            </treeselect>
                          </b-form-group>
                        </b-col>

                        <b-col cols="12" sm="6" md="4" xl="3">
                          <b-form-group label-cols="12" label="Fare Basis" label-size="sm">
                            <b-input-group>
                              <b-form-input v-model="segments.item.farebasiscode" :debounce="options.debounce"
                                :disabled="false" placeholder="Fare Basis" trim></b-form-input>
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary"
                                  @click="segments.item.farebasiscode = ''" :disabled="false">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>

                        <b-col cols="12" sm="6" md="4" xl="3">
                          <b-form-group label-cols="12" label="Fare Type" label-size="sm">
                            <treeselect placeholder="Fare Type" v-model="segments.item.fare_type" :multiple="false"
                              :options="options_faretype">
                            </treeselect>
                          </b-form-group>
                        </b-col>

                      </b-row>
                    </div>

                  </b-tab>

                  <b-tab v-if="item.segments_priced == 1">
                    <template #title>
                      <i class="fa fa-gbp text-primary mr-1"></i> Accounting
                    </template>
                    <b-card class="border mt-0 pb-4"><b-card-body>

                        <div class="px-2 mt-2">
                          <p class="py-3 px-0">
                            <b-row> <b-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm">
                                  <treeselect placeholder="Select blac..." searchPromptText="Type at least 3 chars..."
                                    v-model="segments.item.blac" :clearable="true" :async="true"
                                    :load-options="treeselect_loadBLAC" :show-count="true"
                                    :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                                    search-nested>
                                    <div slot="value-label" slot-scope="{ node }">
                                      {{ node.raw.id }}
                                    </div>
                                  </treeselect>
                                </b-form-group>
                              </b-col>

                              <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Tax" label-size="sm">
                                  <b-input-group>
                                    <b-form-input v-model="segments.item.tax" :debounce="options.debounce"
                                      placeholder="Tax" trim></b-form-input>
                                    <b-input-group-append>
                                      <b-button size="sm" variant="outline-secondary" @click="segments.item.tax = ''">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>

                              <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Fare" label-size="sm">
                                  <b-input-group>
                                    <b-form-input v-model="segments.item.fare" :debounce="options.debounce"
                                      placeholder="Fare" trim></b-form-input>
                                    <b-input-group-append>
                                      <b-button size="sm" variant="outline-secondary" @click="segments.item.fare = ''">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>

                              <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Sell" label-size="sm">
                                  <b-input-group>
                                    <b-form-input v-model="segments.item.fare_sell" :debounce="options.debounce"
                                      placeholder="Sell" trim></b-form-input>
                                    <b-input-group-append>
                                      <b-button size="sm" variant="outline-secondary"
                                        @click="segments.item.fare_sell = ''">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>
                            </b-row>


                          </p>
                        </div>
                      </b-card-body></b-card>

                  </b-tab>

                  <b-tab v-if="segments.item.id">
                    <template #title>
                      <i class="fa fa-comments-o text-primary mr-1"></i> Notes
                    </template>
                    <b-card class="border mt-0 pb-4"><b-card-body>

                        <div class="px-2 mt-2">
                          <p class="py-0 px-0">
                            <b-row>
                              <b-col>
                                <b-form-group label="Notes" label-for="notes" label-cols="12">
                                  <b-form-textarea id="notes" v-model="item.notes" placeholder="Notes" rows="3"
                                    max-rows="6"></b-form-textarea>
                                </b-form-group>
                              </b-col>
                            </b-row>
                          </p>
                        </div>
                      </b-card-body></b-card>

                  </b-tab>

                  <b-tab v-if="segments.item.id">
                    <template #title>
                      <i class="fa fa-history text-primary mr-1"></i> Audit
                    </template>
                    <p class="py-3 px-0">

                      <b-row>
                        <b-col cols="12" sm="6" md="4" xl="3">
                          <b-form-group label="Created At" label-for="created_at" label-cols="12">
                            <b-input-group>
                              <b-input-group-prepend>
                                <b-form-datepicker size="sm" v-model="segments.item.created_at" button-only
                                  label-help="" locale="en-GB" :disabled="readonly()"></b-form-datepicker>
                              </b-input-group-prepend>
                              <b-form-input size="sm" id="date" v-model="segments.item.created_at" type="text"
                                placeholder="YYYY-MM-DD" autocomplete="off" :disabled="readonly()"></b-form-input>
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="segments.item.created_at = null"
                                  :disabled="readonly()">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>

                        <b-col cols="12" sm="6" md="4" xl="3">
                          <b-form-group label="Created By" label-for="created_by" label-cols="12">
                            <b-input-group>
                              <b-form-input type="text" v-model="segments.item.created_by" placeholder="" size="sm"
                                :disabled="true"></b-form-input>
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="segments.item.created_by = ''"
                                  :disabled="readonly()">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>

                        <b-col cols="12" sm="6" md="4" xl="3">
                          <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                            <b-input-group>
                              <b-input-group-prepend>
                                <b-form-datepicker size="sm" v-model="segments.item.updated_at" button-only
                                  label-help="" locale="en-GB" :disabled="readonly()"></b-form-datepicker>
                              </b-input-group-prepend>
                              <b-form-input size="sm" id="date" v-model="segments.item.updated_at" type="text"
                                placeholder="YYYY-MM-DD" autocomplete="off" :disabled="readonly()"></b-form-input>
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="segments.item.updated_at = null"
                                  :disabled="readonly()">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>

                        <b-col cols="12" sm="6" md="4" xl="3">
                          <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                            <b-input-group>
                              <b-form-input type="text" v-model="segments.item.updated_by" placeholder="" size="sm"
                                :disabled="readonly()"></b-form-input>
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="segments.item.updated_by = ''"
                                  :disabled="readonly()">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="12" sm="6" md="4" xl="3">
                          <b-form-group label="ID" label-for="id" label-cols="12">
                            <b-input-group>
                              <b-form-input type="text" v-model="segments.item.id" placeholder="" size="sm"
                                :disabled="true"></b-form-input>
                              <!-- <b-input-group-append>
                              <b-button
                                size="sm"
                                variant="outline-secondary"
                                @click="item.id = ''"
                                :disabled="true"
                              >
                                <i class="fa fa-remove"></i>
                              </b-button>
                            </b-input-group-append> -->
                            </b-input-group>
                          </b-form-group>
                        </b-col>

                      </b-row>
                      <!-- <b-row>
                      <b-col cols="12">
                        <b-form-group
                          label="Data"
                          label-for="data"
                          label-cols="12"
                        >
                          <vue-json-pretty
                            :deep="1"
                            :data="JSON.parse(item.data)"
                          >
                          </vue-json-pretty>
                        </b-form-group> </b-col
                    ></b-row> -->
                    </p>
                  </b-tab>

                </b-tabs>

                <b-tabs v-if="segments.item.id">
                  <b-tab>
                    <template #title>
                      <div class="badgecontainer pr-1 mr-1 w-60px">
                        <i class="fa fa-user-circle text-primary ml-1"></i> Seats
                        <b-badge variant="white" class="edit_tab">
                          {{ segments.item.total }}</b-badge>
                        <!-- /
                        <b-badge variant="primary" class="edit_tab">
                          {{ segments.item.booked }}</b-badge> -->
                      </div>
                    </template>
                    <b-card class="w-100pct my-2 ">
                      <b-card-body class="p-0 mx-n2">
                        <b-row>
                          <b-col cols="12" sm="6" md="4" xl="3">
                            <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                              <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..."
                                v-model="slac" :multiple="true" :clearable="true" :async="true"
                                :load-options="treeselect_loadSLAC" :show-count="true" :flatten-search-results="true"
                                :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                                <div slot="value-label" slot-scope="{ node }">
                                  {{ node.raw.id }}
                                </div>
                              </treeselect>
                            </b-form-group>
                          </b-col>


                          <b-col cols="12" sm="6" md="4" xl="3">
                            <b-form-group label-cols="12" label="SeatsStatus" label-size="sm">
                              <treeselect v-model="seatstatus" :clearable="true" :options="options_seatstatus">
                              </treeselect>
                            </b-form-group>
                          </b-col>

                          <b-col cols="12" sm="6" md="4" xl="3">
                            <b-form-group label-cols="12" label="Name" label-size="sm">
                              <b-input-group>
                                <b-form-input v-model="name" :debounce="options.debounce" placeholder="Name"
                                  trim></b-form-input>
                                <b-input-group-append>
                                  <b-button size="sm" variant="outline-secondary" @click="name = ''">
                                    <i class="fa fa-remove"></i>
                                  </b-button>
                                </b-input-group-append>
                              </b-input-group>
                            </b-form-group>
                          </b-col>

                          <b-col cols="12" sm="6" md="4" xl="3">
                            <b-form-group label-cols="12" label="Mealpref" label-size="sm">
                              <b-input-group>
                                <b-form-input v-model="mealpref" :debounce="options.debounce" placeholder="Mealpref"
                                  trim></b-form-input>
                                <b-input-group-append>
                                  <b-button size="sm" variant="outline-secondary" @click="mealpref = ''">
                                    <i class="fa fa-remove"></i>
                                  </b-button>
                                </b-input-group-append>
                              </b-input-group>
                            </b-form-group>
                          </b-col>

                          <b-col cols="12" sm="6" md="4" xl="3">
                            <b-form-group label-cols="12" label="Seatpref" label-size="sm">
                              <b-input-group>
                                <b-form-input v-model="seatpref" :debounce="options.debounce" placeholder="Seatpref"
                                  trim></b-form-input>
                                <b-input-group-append>
                                  <b-button size="sm" variant="outline-secondary" @click="seatpref = ''">
                                    <i class="fa fa-remove"></i>
                                  </b-button>
                                </b-input-group-append>
                              </b-input-group>
                            </b-form-group>
                          </b-col>

                          <b-col cols="12" sm="6" md="4" xl="3">
                            <b-form-group label-cols="12" label="Seatno" label-size="sm">
                              <b-input-group>
                                <b-form-input v-model="seatno" :debounce="options.debounce" placeholder="Seatno"
                                  trim></b-form-input>
                                <b-input-group-append>
                                  <b-button size="sm" variant="outline-secondary" @click="seatno = ''">
                                    <i class="fa fa-remove"></i>
                                  </b-button>
                                </b-input-group-append>
                              </b-input-group>
                            </b-form-group>
                          </b-col>

                          <b-col cols="12" sm="6" md="4" xl="3">
                            <b-form-group label-cols="12" label="Ticketno" label-size="sm">
                              <b-input-group>
                                <b-form-input v-model="ticketno" :debounce="options.debounce" placeholder="Ticketno"
                                  trim></b-form-input>
                                <b-input-group-append>
                                  <b-button size="sm" variant="outline-secondary" @click="ticketno = ''">
                                    <i class="fa fa-remove"></i>
                                  </b-button>
                                </b-input-group-append>
                              </b-input-group>
                            </b-form-group>
                          </b-col>

                          <b-col cols="12" sm="6" md="4" xl="3" class="mt-4">
                            <b-form-group label-cols="12" label=" " label-size="sm">
                              <b-input-group>

                                <b-form-checkbox id="isvoid" v-model="isvoid" class="z-0">
                                  <div style="padding-top: 0.2em" class="text-primary" id="isvoid-tooltip">Void: in
                                    Notes
                                  </div>
                                </b-form-checkbox>
                              </b-input-group>
                            </b-form-group>
                          </b-col>

                        </b-row>
                      </b-card-body></b-card>

                    <b-row>
                      <b-col>
                        <d-table classdivtable="availtable datatable nested" refid="segments" :icon="seats.icon"
                          :selectmode="'single'" :busy="seats.busy" :tools="seats.tools" :badges="seats.badges"
                          :fields="seats.fields" :items="seats.items" :showpages="false" @load="load"
                          @click="seats_click" @select="seats_select">
                        </d-table>
                      </b-col>
                    </b-row>

                    <b-tabs v-if="seats.item.id" class="gridtabs mt-2">
                      <b-tab>
                        <template #title>
                          <span class="text-primary">{{seats.items.map(o => o.id).indexOf(seats.item.id) + 1
                          }}.</span>
                          <i :class="'fa fa-user-circle text-primary'" class="text-primary ml-1 mr-1"></i>
                          <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span>&nbsp;
                          <span v-if="seats.item.seatstatus == 'OK'"
                            :title="options_seatstatus.find(o => o.id == seats.item.seatstatus).label"
                            class="badge badge-success badge-pill">{{ seats.item.seatstatus }}</span>
                          <span v-if="seats.item.seatstatus == 'HK'"
                            :title="options_seatstatus.find(o => o.id == seats.item.seatstatus).label"
                            class="badge badge-warning badge-pill">{{ seats.item.seatstatus }}</span>
                          <span v-if="seats.item.seatstatus == 'SS'"
                            :title="options_seatstatus.find(o => o.id == seats.item.seatstatus).label"
                            class="badge badge-info badge-pill">{{ seats.item.seatstatus }}</span>

                        </template>

                        <p class="py-0 px-0">
                          <b-card class="border mt-0 "><b-card-body>

                              <div class="px-2 mt-2">

                                <b-row>
                                  <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label="Client SL A/C" label-for="slac" label-cols="12">
                                      <treeselect placeholder="Select SL A/C..." v-model="seats.item.slac"
                                        searchPromptText="Type at least 3 chars..." :clearable="true" :async="true"
                                        :load-options="treeselect_loadSLAC" :show-count="true"
                                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                                        search-nested>
                                        <div slot="value-label" slot-scope="{ node }">
                                          {{ node.raw.id }}
                                        </div>
                                      </treeselect>
                                    </b-form-group>
                                  </b-col>
                                  <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label-cols="12" label="Surname" label-size="sm">
                                      <b-input-group>
                                        <b-form-input v-model="seats.item.surname" :debounce="options.debounce"
                                          :disabled="false" placeholder="Surname" trim></b-form-input>
                                        <b-input-group-append>
                                          <b-button size="sm" variant="outline-secondary"
                                            @click="seats.item.surname = ''" :disabled="false">
                                            <i class="fa fa-remove"></i>
                                          </b-button>
                                        </b-input-group-append>
                                      </b-input-group>
                                    </b-form-group>
                                  </b-col>
                                  <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label-cols="12" label="Firstname" label-size="sm">
                                      <b-input-group>
                                        <b-form-input v-model="seats.item.firstname" :debounce="options.debounce"
                                          :disabled="false" placeholder="Firstname" trim></b-form-input>
                                        <b-input-group-append>
                                          <b-button size="sm" variant="outline-secondary"
                                            @click="seats.item.firstname = ''" :disabled="false">
                                            <i class="fa fa-remove"></i>
                                          </b-button>
                                        </b-input-group-append>
                                      </b-input-group>
                                    </b-form-group>
                                  </b-col>
                                  <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label-cols="12" label="Title" label-size="sm">
                                      <b-input-group>
                                        <b-form-input v-model="seats.item.title" :debounce="options.debounce"
                                          :disabled="false" placeholder="Title" trim></b-form-input>
                                        <b-input-group-append>
                                          <b-button size="sm" variant="outline-secondary" @click="seats.item.title = ''"
                                            :disabled="false">
                                            <i class="fa fa-remove"></i>
                                          </b-button>
                                        </b-input-group-append>
                                      </b-input-group>
                                    </b-form-group>
                                  </b-col>
                                  <b-col cols="12" sm="6" md="6" xl="6">
                                    <b-form-group label-cols="12" label="Notes" label-size="sm">
                                      <b-input-group>
                                        <b-form-input v-model="seats.item.notes" :debounce="options.debounce"
                                          :disabled="false" placeholder="Notes" trim></b-form-input>
                                        <b-input-group-append>
                                          <b-button size="sm" variant="outline-secondary" @click="seats.item.notes = ''"
                                            :disabled="false">
                                            <i class="fa fa-remove"></i>
                                          </b-button>
                                        </b-input-group-append>
                                      </b-input-group>
                                    </b-form-group>
                                  </b-col>


                                  <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label-cols="12" label="Meal Preferences" label-size="sm">
                                      <b-input-group>
                                        <b-form-input v-model="seats.item.mealpref" :debounce="options.debounce"
                                          :disabled="false" placeholder="Meal Preferences" trim></b-form-input>
                                        <b-input-group-append>
                                          <b-button size="sm" variant="outline-secondary"
                                            @click="seats.item.mealpref = ''" :disabled="false">
                                            <i class="fa fa-remove"></i>
                                          </b-button>
                                        </b-input-group-append>
                                      </b-input-group>
                                    </b-form-group>
                                  </b-col>
                                  <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label-cols="12" label="Seat Preferences" label-size="sm">
                                      <b-input-group>
                                        <b-form-input v-model="seats.item.seatpref" :debounce="options.debounce"
                                          :disabled="false" placeholder="Seat Preferences" trim></b-form-input>
                                        <b-input-group-append>
                                          <b-button size="sm" variant="outline-secondary"
                                            @click="seats.item.seatpref = ''" :disabled="false">
                                            <i class="fa fa-remove"></i>
                                          </b-button>
                                        </b-input-group-append>
                                      </b-input-group>
                                    </b-form-group>
                                  </b-col>

                                  <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label-cols="12" label="Seat No" label-size="sm">
                                      <b-input-group>
                                        <b-form-input v-model="seats.item.seatno" :debounce="options.debounce"
                                          :disabled="false" placeholder="Seat No" trim></b-form-input>
                                        <b-input-group-append>
                                          <b-button size="sm" variant="outline-secondary"
                                            @click="seats.item.seatno = ''" :disabled="false">
                                            <i class="fa fa-remove"></i>
                                          </b-button>
                                        </b-input-group-append>
                                      </b-input-group>
                                    </b-form-group>
                                  </b-col>
                                  <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label-cols="12" label="Ticket No" label-size="sm">
                                      <b-input-group>
                                        <b-form-input v-model="seats.item.ticketno" :debounce="options.debounce"
                                          :disabled="false" placeholder="Ticket No" trim></b-form-input>
                                        <b-input-group-append>
                                          <b-button size="sm" variant="outline-secondary"
                                            @click="seats.item.ticketno = ''" :disabled="false">
                                            <i class="fa fa-remove"></i>
                                          </b-button>
                                        </b-input-group-append>
                                      </b-input-group>
                                    </b-form-group>
                                  </b-col>
                                </b-row>
                              </div>
                            </b-card-body>

                            <b-card-footer class="mt-2 mb-2">
                              <b-row>
                                <b-col class="text-left">
                                  <div v-if="busy">
                                    <i class="fa fa-spinner fa-spin text-primary"></i>
                                  </div>
                                  <div v-else>
                                    <span v-html="message_seat"></span>
                                  </div>
                                </b-col>
                                <b-col class="text-right" cols="8">

                                  <b-button squared size="sm" variant="primary" @click="seats_save()"
                                    v-if="user.permissions.includes('charters.save')">
                                    <i class="fa fa-check"></i>
                                    Save It
                                  </b-button>
                                </b-col>
                              </b-row>
                            </b-card-footer>
                          </b-card>
                        </p>
                      </b-tab>
                      <b-tab>
                        <template #title>
                          <i class="fa fa-comments-o text-primary mr-1"></i> Notes
                        </template>
                        <b-card class="border mt-0 pb-4"><b-card-body>

                            <div class="px-2 mt-2">
                              <p class="py-0 px-0">
                                <b-row>
                                  <b-col>
                                    <b-form-group label="Notes" label-for="notes" label-cols="12">
                                      <b-form-textarea id="notes" v-model="seats.item.notes" placeholder="Notes"
                                        rows="3" max-rows="6"></b-form-textarea>
                                    </b-form-group>
                                  </b-col>
                                </b-row>
                              </p>
                            </div>
                          </b-card-body></b-card>

                      </b-tab>
                      <b-tab>
                        <template #title>
                          <i class="fa fa-history text-primary mr-1"></i> Audit
                        </template>
                        <p class="py-3 px-0">

                          <b-row>
                            <b-col cols="12" sm="6" md="4" xl="3">
                              <b-form-group label="Created At" label-for="created_at" label-cols="12">
                                <b-input-group>
                                  <b-input-group-prepend>
                                    <b-form-datepicker size="sm" v-model="seats.item.created_at" button-only
                                      label-help="" locale="en-GB" :disabled="readonly()"></b-form-datepicker>
                                  </b-input-group-prepend>
                                  <b-form-input size="sm" id="date" v-model="seats.item.created_at" type="text"
                                    placeholder="YYYY-MM-DD" autocomplete="off" :disabled="readonly()"></b-form-input>
                                  <b-input-group-append>
                                    <b-button size="sm" variant="outline-secondary"
                                      @click="seats.item.created_at = null" :disabled="readonly()">
                                      <i class="fa fa-remove"></i>
                                    </b-button>
                                  </b-input-group-append>
                                </b-input-group>
                              </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                              <b-form-group label="Created By" label-for="created_by" label-cols="12">
                                <b-input-group>
                                  <b-form-input type="text" v-model="seats.item.created_by" placeholder="" size="sm"
                                    :disabled="true"></b-form-input>
                                  <b-input-group-append>
                                    <b-button size="sm" variant="outline-secondary" @click="seats.item.created_by = ''"
                                      :disabled="readonly()">
                                      <i class="fa fa-remove"></i>
                                    </b-button>
                                  </b-input-group-append>
                                </b-input-group>
                              </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                              <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                                <b-input-group>
                                  <b-input-group-prepend>
                                    <b-form-datepicker size="sm" v-model="seats.item.updated_at" button-only
                                      label-help="" locale="en-GB" :disabled="readonly()"></b-form-datepicker>
                                  </b-input-group-prepend>
                                  <b-form-input size="sm" id="date" v-model="seats.item.updated_at" type="text"
                                    placeholder="YYYY-MM-DD" autocomplete="off" :disabled="readonly()"></b-form-input>
                                  <b-input-group-append>
                                    <b-button size="sm" variant="outline-secondary"
                                      @click="seats.item.updated_at = null" :disabled="readonly()">
                                      <i class="fa fa-remove"></i>
                                    </b-button>
                                  </b-input-group-append>
                                </b-input-group>
                              </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                              <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                                <b-input-group>
                                  <b-form-input type="text" v-model="seats.item.updated_by" placeholder="" size="sm"
                                    :disabled="readonly()"></b-form-input>
                                  <b-input-group-append>
                                    <b-button size="sm" variant="outline-secondary" @click="seats.item.updated_by = ''"
                                      :disabled="readonly()">
                                      <i class="fa fa-remove"></i>
                                    </b-button>
                                  </b-input-group-append>
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col cols="12" sm="6" md="4" xl="3">
                              <b-form-group label="ID" label-for="id" label-cols="12">
                                <b-input-group>
                                  <b-form-input type="text" v-model="seats.item.id" placeholder="" size="sm"
                                    :disabled="true"></b-form-input>

                                </b-input-group>
                              </b-form-group>
                            </b-col>

                          </b-row>

                        </p>
                      </b-tab>
                    </b-tabs>

                    <b-alert v-if="seats.messages.length > 0" show :variant="'success'" class="text-center mt-2 mb-1">
                      <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                          <i class="fa fa-info-circle fa-2x"></i></b-col>
                        <b-col> <span v-html="seats.messages.join('<br/>')"></span></b-col></b-row>
                    </b-alert>

                  </b-tab>

                </b-tabs>

              </b-tab>

              <b-tab>
                <template #title>
                  <i :class="'fa fa-book text-primary'" class="text-primary mr-1"></i>
                  PNR
                  <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span>
                </template>
                <p class="py-0 px-0 mt-2">
                  <b-row>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Locator" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="item.locator" :debounce="options.debounce" placeholder="Locator"
                            trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.locator = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Direction" label-size="sm">
                        <treeselect placeholder="Direction" v-model="item.direction" :clearable="true" :multiple="false"
                          :options="options_direction">
                        </treeselect>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Group Type" label-size="sm">
                        <treeselect placeholder="Group Type" v-model="item.grouptype" :clearable="true"
                          :multiple="false" :options="options_grouptype">
                        </treeselect>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Group Name" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="item.groupname" :debounce="options.debounce" placeholder="Group Name"
                            trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.groupname = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Fare Type" label-size="sm">
                        <treeselect placeholder="Fare Type" v-model="item.fare_type" :multiple="false"
                          :options="options_faretype">
                        </treeselect>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Event" label-size="sm">
                        <treeselect placeholder="Select event..." v-model="item.eventcode" :clearable="true"
                          :async="true" :load-options="treeselect_loadEvent" searchPromptText="Type at least 4 chars..."
                          :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true"
                          :matchKeys="['id']" search-nested :disabled="item.id ? true : false">
                          <div slot="value-label" slot-scope="{ node }">
                            {{ node.raw.id }}
                          </div>
                        </treeselect>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Source" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="item.source" :debounce="options.debounce" placeholder="Source"
                            trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.source = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Branch" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="item.branch" :debounce="options.debounce" placeholder="Branch"
                            trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.branch = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Sector Pricing" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="item.segments_priced" :debounce="options.debounce"
                            placeholder="Sector Pricing" trim :disabled="item.id ? true : false"> </b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Total (Seats)" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="item.total" :debounce="options.debounce" placeholder="Total"
                            trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.total = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Options" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="item.options" :debounce="options.debounce" placeholder="Options"
                            trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.options = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="On Request" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="item.onrequest" :debounce="options.debounce" placeholder="On Request"
                            trim :disabled="item.id ? true : false"> </b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </b-col>



                  </b-row>
                </p>
              </b-tab>

              <b-tab v-if="item.segments_priced == 'false'">
                <template #title>
                  <i class="fa fa-gbp text-primary mr-1"></i> Accounting
                </template>
                <b-card class="border mt-0 pb-4"><b-card-body>

                    <div class="px-2 mt-2">
                      <p class="py-3 px-0">
                        <b-row> <b-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm">
                              <treeselect placeholder="Select blac..." searchPromptText="Type at least 3 chars..."
                                v-model="item.blac" :clearable="true" :async="true" :load-options="treeselect_loadBLAC"
                                :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true"
                                :matchKeys="['id']" search-nested>
                                <div slot="value-label" slot-scope="{ node }">
                                  {{ node.raw.id }}
                                </div>
                              </treeselect>
                            </b-form-group>
                          </b-col>
                          <b-col cols="12" sm="6" md="4" xl="3">
                            <b-form-group label-cols="12" label="Gross" label-size="sm">
                              <b-input-group>
                                <b-form-input v-model="item.fare_sell" :debounce="options.debounce" placeholder="Gross"
                                  trim></b-form-input>
                                <b-input-group-append>
                                  <b-button size="sm" variant="outline-secondary" @click="item.fare_sell = ''">
                                    <i class="fa fa-remove"></i>
                                  </b-button>
                                </b-input-group-append>
                              </b-input-group>
                            </b-form-group>
                          </b-col>

                          <b-col cols="12" sm="6" md="4" xl="3">
                            <b-form-group label-cols="12" label="Tax" label-size="sm">
                              <b-input-group>
                                <b-form-input v-model="item.tax" :debounce="options.debounce" placeholder="Tax"
                                  trim></b-form-input>
                                <b-input-group-append>
                                  <b-button size="sm" variant="outline-secondary" @click="item.tax = ''">
                                    <i class="fa fa-remove"></i>
                                  </b-button>
                                </b-input-group-append>
                              </b-input-group>
                            </b-form-group>
                          </b-col>

                          <b-col cols="12" sm="6" md="4" xl="3">
                            <b-form-group label-cols="12" label="Net" label-size="sm">
                              <b-input-group>
                                <b-form-input v-model="item.fare" :debounce="options.debounce" placeholder="Net"
                                  trim></b-form-input>
                                <b-input-group-append>
                                  <b-button size="sm" variant="outline-secondary" @click="item.fare = ''">
                                    <i class="fa fa-remove"></i>
                                  </b-button>
                                </b-input-group-append>
                              </b-input-group>
                            </b-form-group>
                          </b-col>



                          <b-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <b-form-group label="Deposit Due" label-for="depositdue" label-cols="12">
                              <b-input-group>
                                <b-input-group-prepend>
                                  <b-form-datepicker :disabled="true" size="sm" v-model="item.depositdue_at" button-only
                                    locale="en-GB" :date-format-options="{
                                      year: 'numeric',
                                      month: 'short',
                                      day: '2-digit',
                                      weekday: 'short',
                                    }" label-help=""></b-form-datepicker>
                                </b-input-group-prepend>
                                <b-form-input id="depositdue" :disabled="true"
                                  :value="item.depositdue_at ? this.$helpers.datefield(item.depositdue_at) : null"
                                  type="text" placeholder="YYYY-MM-DD" autocomplete="off"></b-form-input>
                                <b-input-group-append>
                                  <b-button size="sm" variant="outline-secondary" @click="item.depositdue_at = null">
                                    <i class="fa fa-remove"></i>
                                  </b-button>
                                </b-input-group-append>
                              </b-input-group>
                            </b-form-group>
                          </b-col>
                          <b-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <b-form-group label="Deposit Paid?" label-for="depositpaid" label-cols="12">
                              <b-form-radio-group id="depositpaid" v-model="item.depositpaid" :options="[
                                { text: 'Yes', value: true },
                                { text: 'No', value: false },
                              ]" buttons button-variant="outline-success" size="sm"
                                name="radio-btn-outline"></b-form-radio-group>
                            </b-form-group>
                          </b-col>
                          <b-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <b-form-group label="Full Commit" label-for="committed_at" label-cols="12">
                              <b-input-group>
                                <b-input-group-prepend>
                                  <b-form-datepicker :disabled="true" size="sm" v-model="item.committed_at" button-only
                                    locale="en-GB" label-help=""></b-form-datepicker>
                                </b-input-group-prepend>
                                <b-form-input id="committed_at" :disabled="true"
                                  :value="item.committed_at ? this.$helpers.datefield(item.committed_at) : null"
                                  type="text" placeholder="YYYY-MM-DD" autocomplete="off"></b-form-input>
                                <b-input-group-append>
                                  <b-button size="sm" variant="outline-secondary" @click="item.committed_at = null">
                                    <i class="fa fa-remove"></i>
                                  </b-button>
                                </b-input-group-append>
                              </b-input-group>
                            </b-form-group>
                          </b-col>
                          <b-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <b-form-group label="Committed?" label-for="committed" label-cols="12">
                              <b-form-radio-group id="committed" v-model="item.committed" :options="[
                                { text: 'Yes', value: true },
                                { text: 'No', value: false },
                              ]" buttons button-variant="outline-success" size="sm"
                                name="radio-btn-outline"></b-form-radio-group>
                            </b-form-group>
                          </b-col>

                        </b-row>


                      </p>
                    </div>
                  </b-card-body></b-card>

              </b-tab>

              <b-tab>
                <template #title>
                  <i class="fa fa-comments-o text-primary mr-1"></i> Notes
                </template>
                <b-card class="border mt-0 pb-4"><b-card-body>

                    <div class="px-2 mt-2">
                      <p class="py-0 px-0">
                        <b-row>
                          <b-col>
                            <b-form-group label="Notes" label-for="notes" label-cols="12">
                              <b-form-textarea id="notes" v-model="item.notes" placeholder="Notes" rows="3"
                                max-rows="6"></b-form-textarea>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </p>
                    </div>
                  </b-card-body></b-card>

              </b-tab>

              <b-tab>
                <template #title>
                  <i class="fa fa-history text-primary mr-1"></i> Audit
                </template>
                <p class="py-3 px-0">

                  <b-row>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Created At" label-for="created_at" label-cols="12">
                        <b-input-group>
                          <b-input-group-prepend>
                            <b-form-datepicker size="sm" v-model="item.created_at" button-only label-help=""
                              locale="en-GB" :disabled="readonly()"></b-form-datepicker>
                          </b-input-group-prepend>
                          <b-form-input size="sm" id="date" v-model="item.created_at" type="text"
                            placeholder="YYYY-MM-DD" autocomplete="off" :disabled="readonly()"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.created_at = null"
                              :disabled="readonly()">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Created By" label-for="created_by" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.created_by" placeholder="" size="sm"
                            :disabled="true"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.created_by = ''"
                              :disabled="readonly()">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                        <b-input-group>
                          <b-input-group-prepend>
                            <b-form-datepicker size="sm" v-model="item.updated_at" button-only label-help=""
                              locale="en-GB" :disabled="readonly()"></b-form-datepicker>
                          </b-input-group-prepend>
                          <b-form-input size="sm" id="date" v-model="item.updated_at" type="text"
                            placeholder="YYYY-MM-DD" autocomplete="off" :disabled="readonly()"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.updated_at = null"
                              :disabled="readonly()">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.updated_by" placeholder="" size="sm"
                            :disabled="readonly()"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.updated_by = ''"
                              :disabled="readonly()">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="ID" label-for="id" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.id" placeholder="" size="sm"
                            :disabled="true"></b-form-input>
                          <!-- <b-input-group-append>
                              <b-button
                                size="sm"
                                variant="outline-secondary"
                                @click="item.id = ''"
                                :disabled="true"
                              >
                                <i class="fa fa-remove"></i>
                              </b-button>
                            </b-input-group-append> -->
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                  </b-row>
                  <!-- <b-row>
                      <b-col cols="12">
                        <b-form-group
                          label="Data"
                          label-for="data"
                          label-cols="12"
                        >
                          <vue-json-pretty
                            :deep="1"
                            :data="JSON.parse(item.data)"
                          >
                          </vue-json-pretty>
                        </b-form-group> </b-col
                    ></b-row> -->
                </p>
              </b-tab>

            </b-tabs>
          </b-card-body>

          <b-card-footer class="mt-2 ml-1">
            <b-row>
              <b-col class="text-left">
                <!-- <div v-if="busy">
                  <i class="fa fa-spinner fa-spin text-primary"></i>
                </div>
                <div v-else>
                  <span v-html="message"></span>
                </div> -->
              </b-col>
              <b-col class="text-right" cols="8">
                <!-- <b-button squared size="sm" variant="primary" class="mr-1" @click="saveit()"
                  v-if="user.permissions.includes('charters.save')">
                  <i class="fa fa-check pr-1"></i>
                  Save It
                </b-button> -->
                <b-button squared size="sm" variant="secondary" @click="discard">
                  <i class="fa fa-chevron-left"></i>
                  Back
                </b-button>
              </b-col>
            </b-row>
          </b-card-footer>
        </b-card>
      </div>
      <datalist id="list-terminal">
        <option v-for="item in options_terminal" :key="item">{{ item }}</option>
      </datalist>
      <datalist id="list-classes">
        <option v-for="item in options_classes" :key="item">{{ item }}</option>
      </datalist>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";
import { v4 as uuidv4 } from 'uuid';
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";

export default {
  name: "ChartersEdit",
  components: {
    VueJsonPretty,
  },
  mounted() {
    this.item.agent = this.user.initials;
  },
  data() {
    return {
      busy: false,
      showlocator: false,
      disabled: true,
      multiple: true,
      showedit: true,
      canedit: [],
      line: {},
      message: "",
      message_seat: "",
      message_seats: "",
      item: null,
      datestart: { startDate: null, endDate: null },
      dateend: { startDate: null, endDate: null },
      seatstatus: null,
      slac: null,
      name: null,
      mealpref: null,
      seatpref: null,
      seatno: null,
      ticketno: null,
      isvoid: false,
      options_terminal: [
        "HARRODS",
        "SIGNATURE",
        "INFLITE",
        "T1",
        "T2",
        "T3",
        "T4",
        "INTERNATIONAL",
      ],

      options_classes: ["Y", "J", "W", "X"],
      options_grouptype: [
        { id: "gds", label: "GDS" },
        { id: "charter", label: "Charter" },
      ],
      options_direction: [
        { id: "return", label: "Return" },
        { id: "outbound", label: "Outbound" },
        { id: "inbound", label: "Inbound" },
        { id: "additional", label: "Additional" },
      ],
      options_faretype: [
        { id: "published", label: "Published" },
        { id: "private", label: "Private" },
        { id: "mixed-ch", label: "Mixed-ch" },
        { id: "private-ch", label: "Private-ch" },
      ],
      options_cabin: [
        { id: "ECONOMY", label: "ECONOMY" },
        { id: "PREMIUM", label: "PREMIUM" },
        { id: "BUSINESS", label: "BUSINESS" },
        { id: "FIRST", label: "FIRST" },
      ],
      options_seatstatus: [
        { id: "HK", label: "HK - Reserved But Not Ticketed" },
        { id: "OK", label: "OK - Ticketed And Confirmed" },
        { id: "SS", label: "SS - Available To Sell" },
      ],
      options: {
        title: "Edit Group Seat",
        icon_header: "fa fa-ticket",
        icon: "fa fa-plane",
        debounce: 500,
      },
      segments: {
        title: "Segments",
        icon: "fa fa-plane text-primary",
        debounce: 500,
        busy: false,
        tools: "go,export,add,save,deleteconfirm",
        fields: [
          {
            key: "selected",
            label: "...",
          },
          {
            key: "icon",
            label: "",
            class: "text-right w-50px",
          },
          {
            key: "vendorlocator",
            label: "Al Locator",
            sortable: true,
          },
          {
            key: "total",
            label: "Total",
            sortable: true,
          },
          {
            key: "booked",
            label: "Booked",
            sortable: true,
          },
          {
            key: "free",
            label: "Free",
            sortable: true,
          },
          {
            key: "classcode",
            label: "Class",
            sortable: true,
          },
          {
            key: "flightno",
            label: "Flight No",
            sortable: true,
          },
          {
            key: "aircraft",
            label: "Aircraft",
            sortable: true,
          },

          {
            key: "startdate",
            label: "Start DateTime",
            sortable: true,
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .utc(false)
                  .format("DD/MM/YYYY HH:mm");
              }
              return result;
            },
          },

          {
            key: "startcity",
            label: "Start City",
            sortable: true,
          },
          {
            key: "startterminal",
            label: "Start Term",
            sortable: true,
          },
          {
            key: "enddate",
            label: "End DateTime",
            sortable: true,
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .utc(false)
                  .format("DD/MM/YYYY HH:mm");
              }
              return result;
            },
          },
          {
            key: "endcity",
            label: "End City",
            sortable: true,
          },
          {
            key: "endterminal",
            label: "End Term",
            sortable: true,
          },
          // {
          //   key: "classname",
          //   label: "Class Name",
          //   sortable: true,
          // },
          // {
          //   key: "cabin",
          //   label: "Cabin",
          //   sortable: true,
          // },
          // {
          //   key: "duration",
          //   label: "Duration",
          //   sortable: true,
          // },
          // {
          //   key: "distance",
          //   label: "Distance",
          //   class: "text-right",
          //   sortable: true,
          //   totalled: true,
          //   total: 0,
          //   type: "int",
          // },
          {
            key: "fare_type",
            label: "Fare Type",
            sortable: true,
            class: "text-center ",
          },
          // {
          //   key: "fare",
          //   label: "Fare",
          //   sortable: true,
          //   class: "text-right",
          //   totalled: true,
          //   total: 0,
          // },
          // {
          //   key: "tax",
          //   label: "Tax",
          //   sortable: true,
          //   class: "text-right",
          //   totalled: true,
          //   total: 0,
          // },
          // {
          //   key: "fare_sell",
          //   label: "Sell",
          //   sortable: true,
          //   class: "text-right",
          //   totalled: true,
          //   total: 0,
          // },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions",
          },
        ],
        badges: [
          {
            key: "vendorlocator",
            type: "pill",
            class: "secondary",
          },
          {
            key: "classcode",
            type: "pill",
            class: "purple",
          },
          {
            key: "locator",
            type: "pill",
            class: "secondary",
          },
          {
            key: "aircraft",
            type: "pill",
            class: "purple",
          },
          {
            key: "free",
            type: "pill",
            class: "info",
          },
          {
            key: "booked",
            type: "pill",
            class: "success",
          },
          {
            key: "unticketed",
            type: "pill",
            class: "danger",
          },
          {
            key: "options",
            type: "pill",
            class: "secondary",
          },
          {
            key: "total",
            type: "pill",
            class: "white",
          },
          {
            key: "ticketno",
            type: "pill",
            class: "orange",
          },
          {
            key: "classcode",
            type: "pill",
            class: "purple",
          },
          {
            key: "classname",
            type: "pill",
            class: "purple",
          },
          {
            key: "cabin",
            type: "pill",
            class: "pink",
          },
          {
            key: "flightno",
            type: "pill",
            class: "white",
          },
          {
            key: "seatno",
            type: "pill",
            class: "white",
          },
          {
            key: "startcity",
            type: "pill",
            class: "white",
          },
          {
            key: "endcity",
            type: "pill",
            class: "white",
          },
          {
            key: "fare_type",
            type: "badge",
            Unknown: "white",
            Negotiated: "warning",
            Net: "purple",
            Manual: "secondary",
            Published: "white",
            Private: "pink",
            other: "secondary",
            'Mixed-ch': "white",
            'Private-ch': "pink",
            formatter: (value, key, item) => {
              if (value) {
                switch (value.toLowerCase()) {
                  case "unknown":
                    return "Unknown";

                  case "negotiated":
                    return "Negotiated";

                  case "net":
                    return "Net";

                  case "manual":
                    return "Manual";

                  case "published":
                    return "Published";

                  case "private":
                    return "Private";

                  case "mixed-ch":
                    return "Mixed-ch";

                  case "private-ch":
                    return "Private-ch";

                  default:
                    return value;
                }
              }
            },
          },
        ],
        item: {},
        items: [],
        selected: [],
        messages: [],
      },
      seats: {
        title: "Seats",
        icon: "fa fa-user-circle text-primary",
        debounce: 500,
        busy: false,
        // seat_ss,seat_hk,ticket_cx
        tools: "go,export,deleteconfirm,void",
        fields: [
          {
            key: "selected",
            label: "...",
          },
          {
            key: "icon",
            label: "",
            class: "text-right w-50px",
          },
          {
            key: "seatstatus",
            label: "Status",
            sortable: true,
          },
          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
            class: "text-right",
          },
          {
            key: "name",
            label: "Name",
            sortable: true,
            class: "text-right",
          },
          {
            key: "notes",
            label: "Notes",
            sortable: true,
            formatter: (value, key, item) => {
              let result = value;
              if (result) {
                if (result.length > 50) {
                  result = result.slice(0, 47) + "...";
                }
              }
              return result;
            },
          },
          {
            key: "mealpref",
            label: "Meal Preferences",
            sortable: true,
            formatter: (value, key, item) => {
              let result = value;
              if (result) {
                if (result.length > 20) {
                  result = result.slice(0, 17) + "...";
                }
              }
              return result;
            },
          },
          {
            key: "seatpref",
            label: "Seat Preferences",
            sortable: true,
            formatter: (value, key, item) => {
              let result = value;
              if (result) {
                if (result.length > 20) {
                  result = result.slice(0, 17) + "...";
                }
              }
              return result;
            },
          },
          {
            key: "seatno",
            label: "SeatNo",
            sortable: true,
          },

          {
            key: "ticketno",
            label: "TicketNo",
            sortable: true,
          },
          {
            key: "invoiceno",
            label: "InvoiceNo",
            sortable: true,
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions",
          },
        ],
        badges: [
          {
            key: "seatstatus",
            type: "badge",
            HK: "warning",
            OK: "primary",
            SS: "info",
            formatter: (value, key, item) => {
              switch (value) {
                case "HK":
                  return "HK";
                case "OK":
                  return "OK";
                case "SS":
                  return "SS";
                default:
                  return value;
              }
            },
          },
        ],
        item: {},
        items: [],
        selected: [],
        messages: []
      }
    };
  },
  watch: {
    book_slac: {
      async handler(newVal, oldVal) {
        await this.options_passengers();
      },
    },
    seatstatus: {
      async handler(newVal, oldVal) {
        if (this.segments.item.id) {
          await this.seats_load(this.segments.item.id);
        }
      },
    },
    slac: {
      async handler(newVal, oldVal) {
        if (this.segments.item.id) {
          await this.seats_load(this.segments.item.id);
        }
      },
    },
    name: {
      async handler(newVal, oldVal) {
        if (this.segments.item.id) {
          await this.seats_load(this.segments.item.id);
        }
      },
    },
    mealpref: {
      async handler(newVal, oldVal) {
        if (this.segments.item.id) {
          await this.seats_load(this.segments.item.id);
        }
      },
    },
    seatpref: {
      async handler(newVal, oldVal) {
        if (this.segments.item.id) {
          await this.seats_load(this.segments.item.id);
        }
      },
    },
    seatno: {
      async handler(newVal, oldVal) {
        if (this.segments.item.id) {
          await this.seats_load(this.segments.item.id);
        }
      },
    },
    ticketno: {
      async handler(newVal, oldVal) {
        if (this.segments.item.id) {
          await this.seats_load(this.segments.item.id);
        }
      },
    },
    isvoid: {
      async handler(newVal, oldVal) {
        this.seats.messages = []
        if (this.segments.item.id) {
          await this.seats_load(this.segments.item.id);
        }
      },
    },

  },
  methods: {
    async load() {

      let variables = {
        id: this.idselected,
      };

      try {
        const response = await this.$apollo.query({
          query: gql`
            query grouppnrs($id: String) {
              grouppnrs(id: $id) {
                id
                grouptype
                eventcode
                direction
                locator                
                groupname
                source
                branch 
                onrequest
                agent
                notes
                routing
                startdate
                flightno
                classcode
                aircraft
                fare_type
                total
                options
                booked
                free
                unticketed
                data     
                blac        
                total
                tax
                fare
                fare_sell        
                depositdue_at
                depositpaid
                committed_at
                committed
                notes
                segments_priced
                segments {
                  id
                  total
                  booked
                  options
                  onrequest
                  free                  
                  vendorlocator
                  flightno
                  marketingcarrier
                  operatingcarrier
                  marketingcarriername
                  operatingcarriername
                  startdate
                  startcity
                  startcityname
                  startterminal
                  enddate
                  endcity
                  endcityname
                  endterminal
                  aircraft
                  aircraftname
                  classcode
                  classname
                  cabin
                  duration
                  distance
                  farebasiscode
                  tax
                  fare
                  fare_sell
                  fare_type
                  depositdue_at
                  depositpaid
                  committed
                  committed_at
                  blac
                  issued_at  
                  notes
                  updated_at
                  updated_by   
                  created_at
                  created_by                  
                }
                updated_at
                updated_by
                created_at
                created_by
              }
            }
          `,
          variables,
        });

        this.item = response.data.grouppnrs[0];
        this.segments.items = this.item.segments;

      } catch (error) {
        console.log(error);
      }


    },
    async segments_click(a, ss) {

      console.log("segments_click", a, ss);
      switch (a) {
        case "go":
          this.component = null;
          //   this.dateSelector();
          await this.load();
          break;
        case "add":
          console.log('segments_add')
          let segment = {}
          if (!this.segments.item.updated_at) {
            segment = {
              id: uuidv4(),
              vendorlocator: "",
              flightno: "",
              marketingcarrier: "",
              operatingcarrier: "",
              marketingcarriername: "",
              operatingcarriername: "",
              startdate: "",
              starttime: "",
              startcity: "",
              startcityname: "",
              startterminal: "",
              enddate: "",
              endtime: "",
              endcity: "",
              endcityname: "",
              endterminal: "",
              aircraft: "",
              aircraftname: "",
              classcode: "",
              classname: "",
              cabin: "",
              duration: "",
              distance: "",
              farebasiscode: "",
            }
          } else {
            segment = { ...this.segments.item, id: uuidv4() }
          }
          this.segments.items.push(segment)
          break;
        case "save":
          await this.saveit();
          break;
        case "delete":
          this.segment_delete(ss)
          break;

        // case "back":
        //   this.discard();
        //   break;

        // case "paste":
        //   this.$bvModal.show("flights-paste");
        //   break;
      }
    },
    async segments_select(ss, tools) {
      console.log("segments_select", ss);

      let state = this.segments;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "export"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit", "notes"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }

      if (state.selected.length > 0) {
        state.item = state.selected[0]; // WHAT YOU SELECTED

        if (state.item.startdate) {
          let v = this.$moment.unix(state.item.startdate / 1000).utc(false).format("YYYY-MM-DD HH:mm")
          this.datestart = { startDate: v, endDate: v }
        }
        if (state.item.enddate) {
          let v = this.$moment.unix(state.item.enddate / 1000).utc(false).format("YYYY-MM-DD HH:mm")
          this.dateend = { startDate: v, endDate: v }
        }

        await this.seats_load(state.item.id)
      } else {
        state.item = {}
      }

    },
    async segment_delete(ss) {
      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        // type: "segment",
        rows,
      };

      console.log(variables);
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation groupsegments_delete($rows: [GroupSegment_input]) {
              groupsegments_delete(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.load();
    },
    async seats_load(groupsegment_id) {

      this.seats.busy = true
      console.log('Seats attached to segement: ', groupsegment_id)
      let variables = {
        groupsegment_id,
        seatstatus: this.seatstatus,
        slac: this.slac ? this.slac.join(",") : null,
        name: this.name,
        mealpref: this.mealpref,
        seatpref: this.seatpref,
        seatno: this.seatno,
        ticketno: this.ticketno,
        isvoid: this.isvoid
      };

      try {
        const response = await this.$apollo.query({
          query: gql`
            query groupseats(
              $groupsegment_id: String,
            $seatstatus: String,
            $slac: String,
            $name: String,
            $mealpref: String,
            $seatpref: String,
            $seatno: String,
            $ticketno: String,
            $isvoid: Boolean) {
              groupseats(
                groupsegment_id: $groupsegment_id
                seatstatus: $seatstatus
                slac: $slac
                name: $name
                mealpref: $mealpref
                seatpref: $seatpref
                seatno: $seatno
                ticketno: $ticketno
                isvoid: $isvoid) {
                id
                slac
                ticketno
                invoiceno
                name
                title                    
                firstname
                surname
                mealpref
                seatpref
                seatno
                seatstatus
                notes
                updated_at
                updated_by
                created_at
                created_by
              }
            }
          `,
          variables,
        });

        this.seats.items = response.data.groupseats;

      } catch (error) {
        console.log(error);
      }
      this.seats.busy = false
    },
    async seats_click(a, ss) {

      let state = this.seats;

      switch (a) {

        case "go":
          this.component = null;
          //   this.dateSelector();
          await this.load();
          break;

        case "void":
          this.voidit()
          break;


        case "delete":
          this.seat_delete(ss)
          break;

      }
    },
    async seats_select(ss, tools) {
      console.log("seats_select", ss);

      let state = this.seats;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "export", "seat_hk", "seat_ss"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit", "notes"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        // JUST FOR VOID
        let v = this.isvoid
        enabled = ["void"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled =
              state.items.length > 0 && v == true ? false : true

          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }

      if (state.selected.length > 0) {
        state.item = state.selected[0]; // WHAT YOU SELECTED
      } else {
        state.item = {}
      }
    },
    async seats_save() {

      if (this.seats.item) {
        let rows = [this.cleanit(this.seats.item)];
        delete rows[0].name
        let variables = {
          rows,
        };
        try {
          const response = await this.$apollo.mutate({
            mutation: gql`
            mutation groupseats_save(
              $rows: [GroupSeat_input]
            ) {
              groupseats_save(rows: $rows) {
                id
              }
            }
          `,
            variables,
          });
          this.message_seat = "<span class='text-primary'>Saved it.</span>";
        } catch (error) {
          this.message_seat = "<span class='text-danger'>" + error.message + "</span>";
        }

      }

    },

    async seat_delete(ss) {
      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        // type: "seat",
        rows,
      };

      console.log(variables);
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation groupseats_delete($rows: [GroupSeat_input]) {
              groupseats_delete(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.seats_load(this.segments.item.id);
    },

    async saveit() {
      this.busy = true;

      let rows = [this.cleanit(this.item)];

      let variables = {
        rows,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation grouppnrs_save(
              $rows: [GroupPnr_input]
            ) {
              grouppnrs_save(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
    readonly(property) {
      let result = true;
      if (this.user.permissions.includes("tickets.save")) {
        this.canedit.forEach(function (action, index) {
          if (property == action) {
            result = false;
          }
        });
      }
      return result;
    },

    async voidit() {

      let variables = {
        rows: this.seats.items,
      };

      console.log(variables);
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation groupseats_void($rows: [GroupSeat_input]) {
              groupseats_void(rows: $rows) 
            }
          `,
          variables,
        });

        this.seats.messages = response.data.groupseats_void;

      } catch (error) {
        console.log(error);
      }

    },
  },
};
</script>